import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgAhaBhaTonerSolutionGlyph from './svgs/AhaBhaTonerSolutionGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var ahaBhaTonerSolutionGlyph = (props => useIcon(SvgAhaBhaTonerSolutionGlyph, SvgAhaBhaTonerSolutionGlyph, props));

export { ahaBhaTonerSolutionGlyph as default };
